import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from "@angular/material/dialog";
import { BaseComponent } from "../../../../../../common/components/base.component";
import { HubApiService } from 'services/hub.api.service';
import { ImageService } from "../../../../../../services/image.service";
import { ButtonTriggerEvent } from 'common/components';
import {
    SearchGooglePlaceResultModalActions,
    SearchGooglePlaceResultModalData
} from './search.google.place.result.modal.provider';
import { AlertifyService } from "../../../../../../services/alertify.service";
import { ShowInfoModalComponent } from "../../../../show.info.modal/show.info.modal.component";
import { InfoModalData, ShowInfoModalActions } from "../../../../show.info.modal/show.info.modal.provider";
import { ModalService } from "../../../../../../common/services/modal.service";
import { ImageSelectorCommand } from 'common/components/image.selector/image.selector.component';
import { HubGooglePlaceBasicData } from "../../../../../../models/hub/hub.google.place.data";
import { EditPlaceCategoryModalActions } from '../../../../edit.place.category.modal/edit.place.category.modal.provider';
import { EditPlaceCategoryModalComponent } from '../../../../edit.place.category.modal/edit.place.category.modal.component';
import { HubPlace } from '../../../../../../models/hub/hub.place';
import { CustomDefaultPlaceCategoryStore } from '../../../../../../stores/hub.calendar.store';
import { clone, isEmptyObject, isNullOrUndefined } from '../../../../../../common/extensions';
import { CustomDefaultPlaceCategory } from '../../../../../../commands/pagination.query.command';

@Component({
    templateUrl: './search.google.place.result.modal.component.html',
    styleUrls: ['./search.google.place.result.modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SearchGooglePlaceResultModalComponent extends BaseComponent {
    public data: SearchGooglePlaceResultModalData;
    public command = new ImageSelectorCommand();
    public selectedImageData = null;
    public isApproved = true;
    public isUseDefaultCustomPlaceCategory: boolean = true;

    constructor(private dialogRef: MatDialogRef<SearchGooglePlaceResultModalComponent>,
        private actions: SearchGooglePlaceResultModalActions,
        private hubApiService: HubApiService,
        public imageService: ImageService,
        private alertify: AlertifyService,
        private modalService: ModalService,
        private formBuilder: FormBuilder,
        private customDefaultPlaceCategoryStore: CustomDefaultPlaceCategoryStore,
        data: SearchGooglePlaceResultModalData) {
        super();
        this.data = Object.assign({}, data);

        // set the first place checkbox checked
        if (this.data.places && this.data.places.length > 0 && !this.data.places[0].existed) {            
            this.data.places[0].checked = true;
        }

        this.customDefaultPlaceCategoryStore.CustomDefaultPlaceCategoryCommand.takeUntil(this.isDestroyed).subscribe(
            (category: CustomDefaultPlaceCategory) => {
                if (!isEmptyObject(category)) {
                    this.isUseDefaultCustomPlaceCategory = category.useDefault;
                }
            }
        );
    }

    public close(): void {
        if (this.actions.cancel) {
            this.actions.cancel();
        }

        this.dialogRef.close();
    }

    public notAllowed(place: HubGooglePlaceBasicData) {
        return !this.data.allowedCategories.any(x => place.types.any(y => x === y));
    }

    public isAllPlaceCategoriesNotMatched() {
        const result = this.data.places
            .filter(x => x.checked)
            .any(place => this.data.allowedCategories.any(category => place.types.any(type => category === type)));
        return !result
    }

    public showEditCategoryModal(place: HubGooglePlaceBasicData) {
        let actions = <EditPlaceCategoryModalActions>{
            confirm: (event: ButtonTriggerEvent, category) => {
                place.types = category.categoryList;
            },
        };

        const placeCategories = clone(place.types);
        this.modalService.show({
            component: EditPlaceCategoryModalComponent,
            providers: [
                { provide: EditPlaceCategoryModalActions, useValue: actions },
                {
                    provide: HubPlace,
                    useValue: {
                        hubName: this.data.hubName,
                        categoryText: placeCategories.join(', '),
                        categoryList: placeCategories || [],
                    } as HubPlace,
                },
            ],
            panelClass: 'width-modal-70p',
        });
    }

    public async confirm(event: ButtonTriggerEvent) {
        if (!this.data.places.any(x => x.checked)) {
            this.alertify.warning('Please select at least one place you want to add');
            event.complete();
            return;
        }
        if (this.data.places.any(x => !x.types.length)) {
            this.alertify.warning('Please select at least one type for the places you want to add');
            event.complete();
            return;
        }

        this.hubApiService.saveGooglePlace(this.data.hubName, this.isApproved, this.data.places.filter(x => x.checked).first())
            .finally(event.complete)
            .subscribe(data => {
                let icons = [], text = [];
                if (data.saved) {
                    icons.push({ icon: 'check', color: 'green' });
                    text.push(`${data.saved} place(s) saved successfully`);
                }

                if (data.updated) {
                    icons.push({ icon: 'cached', color: 'green' });
                    text.push(`${data.updated} place(s) updated`);
                }

                this.modalService.show({
                    component: ShowInfoModalComponent,
                    providers: [
                        { provide: ShowInfoModalActions, useValue: null },
                        {
                            provide: InfoModalData,
                            useValue: new InfoModalData('Result', icons, text)
                        }
                    ],
                    panelClass: 'width-modal-3'
                });

                this.dialogRef.close();
            });
    }

    public updateImage($event, place: HubGooglePlaceBasicData) {
        place.uploadedImage = $event || null;
    }

    public selectedChanged(place: HubGooglePlaceBasicData) {
        this.data.places.filter(x => x.place_id !== place.place_id).forEach(y => y.checked = false);
    }

    public isTypeBlocked(type) {
        return this.data.blockedCategories.indexOf(type) >= 0;
    }

    public removeType(place, type) {
        place.types = place.types.filter(x => x !== type);
        console.log(place.types);
    }  
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/edit.account/content.management/search.google.place/search.google.place.result.modal/search.google.place.result.modal.component.ts